<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="Author-tp">Desnà O’Neill</p>
<p class="Title-tp">When Humpty Asked for Help</p>
<div class="_idGenObjectLayout-1">
<div class="Imprint" id="_idContainer000">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/Logo-for-titlepages-new-CMYK-transparent.jpg"/>
</div>
</div>
<p class="Illustrator-tp">Illustrated by Anna Johnston</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398481954_EPUB1.vue?62460e4e